module.exports = __webpack_public_path__ + "img/sj.55e02eac.svg";